import { Box, Divider, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const LINKS = [
  { label: 'Privacy',              path: '/privacy-policy' },
  { label: 'Cookies',              path: '/cookie-policy' },
  { label: 'Terms',                path: '/terms' },
  { label: 'Contact / Support',    path: '/contact-support' },
  { label: 'DSA Legal Information', path: '/dsa-legal-information' },
  // External page — no static route in this app, so it opens the company site in a new tab.
  { label: 'Data Protection Officer', href: 'https://www.globalmobisoft.com/dataprotectionofficer' },
];

export default function Footer({ dark = false, fixed = false }) {
  const isFixed = dark || fixed;

  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: { xs: 'center', sm: 'space-between' },
        textAlign: 'center',
        flexWrap: 'wrap',
        gap: 1,
        px: 3,
        py: 1.5,
        ...(isFixed
          ? { position: 'fixed', bottom: 0, left: 0, right: 0 }
          : { mt: 'auto', borderTop: '1px solid #CBD5E1', backgroundColor: '#f1f5f9' }),
        ...(!dark && isFixed && { borderTop: '1px solid #CBD5E1', backgroundColor: '#f1f5f9' }),
      }}
    >
      <Typography variant="caption" sx={{ color: dark ? 'rgba(255,255,255,0.55)' : '#64748b', whiteSpace: 'nowrap' }}>
        © {new Date().getFullYear()} GlobalMobiSoft. All rights reserved.
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', gap: 0.5 }}>
        {LINKS.map((link, i) => (
          <Box key={link.label} sx={{ display: 'flex', alignItems: 'center' }}>
            {i > 0 && (
              <Divider
                orientation="vertical"
                flexItem
                sx={{ mx: 0.75, borderColor: dark ? 'rgba(255,255,255,0.25)' : '#CBD5E1', alignSelf: 'center', height: 12 }}
              />
            )}
            <Link
              {...(link.href
                ? { href: link.href, target: '_blank', rel: 'noopener noreferrer' }
                : { component: RouterLink, to: link.path })}
              underline="hover"
              variant="caption"
              sx={dark
                ? { color: 'rgba(255,255,255,0.75)', '&:hover': { color: '#ffffff' } }
                : { color: '#5383b3', fontFamily: 'var(--font-ui)', '&:hover': { color: '#0a326d' } }
              }
            >
              {link.label}
            </Link>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
